require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-civil-society-calls-for-congress-to-meet-u-s-comm.json") })
        }
      }, "path---en-us-update-civil-society-calls-for-congress-to-meet-u-s-comm");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-civil-society-calls-for-congress-to-meet-u-s-comm!./.cache/json/en-us-update-civil-society-calls-for-congress-to-meet-u-s-comm.json
// module id = 638
// module chunks = 231608221292675